module.exports = __webpack_public_path__ + "img/step-4.9268cc02.jpg";